import { OptionsRowType, OptionsWrapEnum } from '../../common/enums/carousel/carousel.enum';
import { isVac } from 'utilities/is-vac';


interface UseSettingsRowPropsModel {
  rowId: number;
  option: OptionsWrapEnum;
}

interface UseSettingsRowModel {
  settings: OptionsRowType[];
}

export const settingsRowL = [
  [
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Type1,
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Type1,
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
  ],
  [
    OptionsRowType.Type1,
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Type1,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Type1,
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Type1,
  ],
  [
    OptionsRowType.Stub,
    OptionsRowType.Type1,
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Type1,
    OptionsRowType.Stub,
  ],
  [
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Type1,
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Type1,
    OptionsRowType.Stub,
    OptionsRowType.Type,
  ],
  [
    OptionsRowType.Stub,
    OptionsRowType.Type1,
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Type1,
    OptionsRowType.Stub,
    OptionsRowType.Type1,
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Type1,
    OptionsRowType.Stub,
  ],
];

export const settingsRowM = [
  [
    OptionsRowType.Stub,
    OptionsRowType.Type1,
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Type1,
    OptionsRowType.Stub,
  ],
  [
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Type1,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Type1,
    OptionsRowType.Stub,
    OptionsRowType.Type,
  ],
  [
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
  ],
  [
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Type,
  ],
  [
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Type1,
    OptionsRowType.Stub,
    OptionsRowType.Type1,
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
  ],
];

export const settingsRowMVAC = [
  [
    OptionsRowType.Stub,
    OptionsRowType.Type1,
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Type1,
    OptionsRowType.Stub,
  ],
  [
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Type1,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Type1,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
  ],
  [
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
  ],
  [
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
  ],
  [
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Type1,
    OptionsRowType.Stub,
    OptionsRowType.Type1,
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
  ],
];

export const settingsRowS = [
  [
    OptionsRowType.Type1,
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Type1,
  ],
  [
    OptionsRowType.Stub,
    OptionsRowType.Type1,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Type1,
    OptionsRowType.Stub,
  ],
  [
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Type,
  ],
  [
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
  ],
  [
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Type1,
    OptionsRowType.Stub,
    OptionsRowType.Type1,
    OptionsRowType.Stub,
    OptionsRowType.Type,
  ],
];

export const settingsRowMobile = [
  [
    OptionsRowType.Stub,
    OptionsRowType.Type1,
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
  ],
  [
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Type1,
  ],
  [
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Type1,
    OptionsRowType.Stub,
  ],
  [
    OptionsRowType.Type1,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Type,
  ],
  [
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
  ],
  [
    OptionsRowType.Type1,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Type,
  ],
  [
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Type1,
    OptionsRowType.Stub,
  ],
  [
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Type1,
  ],
  [
    OptionsRowType.Stub,
    OptionsRowType.Type1,
    OptionsRowType.Stub,
    OptionsRowType.Type1,
    OptionsRowType.Stub,
  ],
];

export const settingsRowMobileVAC = [
  [
    OptionsRowType.Stub,
    OptionsRowType.Type1,
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
  ],
  [
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Type,
  ],
  [
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Type1,
    OptionsRowType.Stub,
  ],
  [
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Type,
  ],
  [
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
  ],
  [
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Stub,
    OptionsRowType.Type,
  ],
  [
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Type1,
    OptionsRowType.Stub,
  ],
  [
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
    OptionsRowType.Type,
  ],
  [
    OptionsRowType.Stub,
    OptionsRowType.Type1,
    OptionsRowType.Stub,
    OptionsRowType.Type,
    OptionsRowType.Stub,
  ],
];

const settingsMap: Record<string, OptionsRowType[][]> = isVac() ? {
  [OptionsWrapEnum.mobile]: settingsRowMobileVAC,
  [OptionsWrapEnum.m]: settingsRowMVAC,
  [OptionsWrapEnum.xm]: settingsRowMVAC,
  [OptionsWrapEnum.s]: settingsRowS
} : {
  [OptionsWrapEnum.mobile]: settingsRowMobile,
  [OptionsWrapEnum.m]: settingsRowM,
  [OptionsWrapEnum.s]: settingsRowS
};

export const getSettingsRow = ({
  rowId,
  option,
}: UseSettingsRowPropsModel): UseSettingsRowModel => {
  const settings: OptionsRowType[] = [];

  // if (option === OptionsWrapEnum.l) {
  //   settings.push(...(settingsRowL[rowId] ? settingsRowL[rowId] : []));
  // }
  const selectedSettings = settingsMap[option]?.[rowId] ?? [];
  settings.push(...selectedSettings);

  return {
    settings,
  };
};
